import styled from '@emotion/styled'
import { colors } from '../../../../../../__styling/settings/colors'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import { getTrackBackground } from 'react-range'
import { transition } from '../../../../../../__styling/style-mixins'
import { IconSpeaker } from '../../../../../../icons/IconSpeaker/IconSpeaker'

export const StyledVolumeControlWrapper = styled('div')({
    display: 'flex',
    height: '100%',
    alignItems: 'center',
})

interface StyledVolumeControlTrackProps {
    value: number
}

export const StyledVolumeControlTrack = styled('div')<
    StyledVolumeControlTrackProps
>(({ value }) => ({
    width: '100%',
    height: calcRem(40),
    '&::after': {
        content: `''`,
        position: 'absolute',
        height: calcRem(2),
        width: '100%',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        borderRadius: calcRem(4),
        background: getTrackBackground({
            colors: [colors.white, colors.white50],
            min: 0,
            max: 1,
            values: [value],
        }),
    },
}))

interface StyledVolumeControlHandleProps {
    isDragged: boolean
}

export const StyledVolumeControlHandle = styled('div')<
    StyledVolumeControlHandleProps
>(({ isDragged }) => ({
    display: 'flex',
    height: calcRem(40),
    width: calcRem(40),
    borderRadius: calcRem(40),
    justifyItems: 'center',
    alignItems: 'center',
    justifyContent: 'center',

    '&::after': {
        content: `''`,
        background: colors.white,
        height: calcRem(10),
        width: calcRem(10),
        borderRadius: calcRem(10),
        ...transition({ properties: ['transform'], speed: 'fast' }),
    },

    transform: isDragged ? 'scale(1.5)' : 'none',

    '&:hover::after': {
        transform: 'scale(1.5)',
    },
}))

interface StyledVolumeButtonProps {
    inactive?: boolean
}

export const StyledVolumeButton = styled('button')<StyledVolumeButtonProps>({
    display: 'flex',
    height: calcRem(40),
    width: calcRem(40),
    borderRadius: calcRem(40),
    justifyItems: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',

    background: 'none',
    border: 'none',
})

interface StyledIconSpeakerProps {
    inactive?: boolean
}

export const StyledIconSpeaker = styled(IconSpeaker)<StyledIconSpeakerProps>(
    ({ inactive }) => ({
        width: calcRem(18),
        opacity: inactive ? 0.5 : 1,
    }),
)
